// Material Kit 2 React Base Styles

import pxToRem from "../functions/pxToRem";
import colors from "./colors";

// Material Kit 2 React Helper Functions

const { border } = colors;

export default {
  borderColor: border.medium,

  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs: pxToRem(1.6),
    sm: pxToRem(4),
    md: pxToRem(6),
    lg: pxToRem(8),
    xl: pxToRem(12),
    xxl: pxToRem(16),
    xxxl: pxToRem(30),
    xxxxl: pxToRem(40),
    section: pxToRem(160),
  },
};
